import { FC, PropsWithChildren, ReactNode } from "react";

import { usePageContext } from "@ryde/redux";

import { HeaderBottomCustom, HeaderBottomEntity } from "./parts";

interface IHeaderBottom extends PropsWithChildren {
  customRightComponent?: ReactNode | null;
  customHeaderBottomLeftComponent?: ReactNode | null;
  rightActions?: ReactNode;
}

export const HeaderBottom: FC<IHeaderBottom> = ({
  children,
  customRightComponent,
  customHeaderBottomLeftComponent,
  rightActions,
}) => {
  const { entity } = usePageContext();
  return (
    <>
      {entity && entity !== "unknown" ? (
        <HeaderBottomEntity
          customRightComponent={customRightComponent}
          customHeaderBottomLeftComponent={customHeaderBottomLeftComponent}
          rightActions={rightActions}
        >
          {children}
        </HeaderBottomEntity>
      ) : (
        <HeaderBottomCustom customRightContent={customRightComponent}>
          {children}
        </HeaderBottomCustom>
      )}
    </>
  );
};
